import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { MasterdataStateType } from '@redux/types'

// initial state
const initialState: MasterdataStateType = {
	// trigger
	triggerGetMainMasterdata: false,

	mainMasterdata: {
		exchangeRate: 0,
		fedexFuelSurchargeRate: 0,
		issuedDate: '',
	},
}

const slice = createSlice({
	name: 'masterdata',
	initialState,
	reducers: {
		TRIGGER_GET_MAIN_MASTER_DATA: (
			state: MasterdataStateType,
			action: PayloadAction<boolean>,
		) => {
			state.triggerGetMainMasterdata = action.payload
		},

		// main
		MAIN_MAINMASTER_DATA: (
			state: MasterdataStateType,
			action: PayloadAction<MasterdataStateType['mainMasterdata']>,
		) => {
			state.mainMasterdata = action.payload
		},
	},
})

export const masterdataActions = slice.actions
export default slice.reducer
